
export class ToolsHelper
{
  public static diffObjValues(object, key) {
    return [... new Map(object.map(item => [item[key], item])).values()]
  }
}
